import { useEffect } from 'react'

export default function Modal({ session: s, onClose }) {
  useEffect(() => {
    const handler = (e) => { if (e.key === 'Escape') onClose() }
    window.addEventListener('keydown', handler)
    return () => window.removeEventListener('keydown', handler)
  }, [onClose])

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => { document.body.style.overflow = '' }
  }, [])

  return (
    <>
      <style>{`
        @keyframes modal-slide-up {
          from { opacity: 0; transform: translate(-50%, calc(-50% + 24px)); }
          to { opacity: 1; transform: translate(-50%, -50%); }
        }
        @keyframes backdrop-fade {
          from { opacity: 0; }
          to { opacity: 1; }
        }
      `}</style>
      {/* Backdrop */}
      <div onClick={onClose} style={{
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.7)',
        zIndex: 200, backdropFilter: 'blur(2px)', animation: 'backdrop-fade 0.25s ease forwards',
      }} />

      {/* Modal */}
      <div style={{
        position: 'fixed', top: '50%', left: '50%',
        transform: 'translate(-50%, -50%)',
        animation: 'modal-slide-up 0.35s cubic-bezier(0.22, 1, 0.36, 1) forwards',
        zIndex: 201, width: 'min(560px, 90vw)',
        background: 'var(--pitch)', color: 'var(--bone)',
        padding: 'clamp(32px, 5vw, 48px)',
        maxHeight: '80vh', overflowY: 'auto',
      }}>

        {/* Close button */}
        <button onClick={onClose} style={{
          position: 'absolute', top: 20, right: 24,
          background: 'none', border: 'none', cursor: 'pointer',
          fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.2em',
          textTransform: 'uppercase', color: 'rgba(255,255,255,0.3)',
          transition: 'color 0.15s',
        }}
          onMouseEnter={e => e.target.style.color = 'var(--bone)'}
          onMouseLeave={e => e.target.style.color = 'rgba(255,255,255,0.3)'}>
          Close ✕
        </button>

        {/* Eyebrow */}
        <div style={{
          fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.22em',
          textTransform: 'uppercase', color: 'rgba(255,255,255,0.25)', marginBottom: 16,
        }}>
          {s.apparatusLabel} · {s.durationMins} min
        </div>

        {/* Title */}
        <div style={{
          fontFamily: 'var(--f-d)', fontSize: 'clamp(28px, 5vw, 40px)',
          letterSpacing: '0.04em', lineHeight: 1, marginBottom: 24,
        }}>
          {s.title}
        </div>

        <hr style={{ border: 'none', borderTop: '1px solid rgba(255,255,255,0.08)', marginBottom: 24 }} />

        {/* Description */}
        {s.description ? (
          <p style={{
            fontSize: 14, fontWeight: 300, color: 'rgba(255,255,255,0.6)',
            lineHeight: 1.85, whiteSpace: 'pre-line',
          }}>
            {s.description}
          </p>
        ) : (
          <p style={{ fontSize: 14, fontWeight: 300, color: 'rgba(255,255,255,0.3)', lineHeight: 1.85 }}>
            No description available.
          </p>
        )}

        {/* Details */}
        <div style={{ marginTop: 32, display: 'flex', flexDirection: 'column', gap: 10 }}>
          {s.locationLine && (
            <div style={{ display: 'flex', gap: 16, alignItems: 'baseline' }}>
              <span style={{ fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.25)', minWidth: 80 }}>Location</span>
              <span style={{ fontSize: 13, fontWeight: 300, color: 'rgba(255,255,255,0.5)' }}>{s.locationLine}</span>
            </div>
          )}
          <div style={{ display: 'flex', gap: 16, alignItems: 'baseline' }}>
            <span style={{ fontFamily: 'var(--f-m)', fontSize: 9, letterSpacing: '0.18em', textTransform: 'uppercase', color: 'rgba(255,255,255,0.25)', minWidth: 80 }}>Price</span>
            <span style={{ fontSize: 13, fontWeight: 300, color: 'rgba(255,255,255,0.5)' }}>{s.price}</span>
          </div>
        </div>

        {/* CTA */}
        {!s.isFull && (
          <a href={s.bookingUrl} target="_blank" rel="noopener noreferrer"
            style={{
              display: 'inline-block', marginTop: 32,
              padding: '13px 28px', background: 'var(--bone)', color: 'var(--pitch)',
              fontFamily: 'var(--f-m)', fontSize: 10, letterSpacing: '0.22em',
              textTransform: 'uppercase', textDecoration: 'none', borderRadius: 2,
            }}>
            Book this session →
          </a>
        )}
      </div>
    </>
  )
}
